/**
 * 기능 소개 그리드 컴포넌트
 * 랜딩 페이지의 기능 소개 섹션을 렌더링
 */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.875rem;\n  font-weight: bold;\n  text-align: center;\n  margin-bottom: 3rem;\n  color: #111827;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: grid;\n  gap: 1rem;\n  grid-template-columns: 1fr;\n  \n  @media (min-width: 640px) {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n  }\n  \n  @media (min-width: 1024px) {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 2rem;\n  }\n  \n  @media (min-width: 1280px) {\n    grid-template-columns: repeat(3, minmax(0, 400px));\n    justify-content: center;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  height: 100%;\n  width: 100%;\n  max-width: 100%;\n  background-color: #ffffff;\n  border: 1px solid #e5e5e5;\n  transition: all 0.3s ease;\n  overflow: hidden;\n  \n  &:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n    border-color: var(--primary, #3b82f6);\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  padding: 1rem;\n  \n  @media (min-width: 640px) {\n    padding: 1.25rem;\n  }\n  \n  @media (min-width: 1024px) {\n    padding: 1.5rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  width: 48px;\n  height: 48px;\n  margin: 0 auto 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n  border-radius: 12px;\n  font-size: 1.5rem;\n  \n  @media (min-width: 640px) {\n    width: 56px;\n    height: 56px;\n    font-size: 1.75rem;\n    border-radius: 14px;\n  }\n  \n  @media (min-width: 1024px) {\n    width: 64px;\n    height: 64px;\n    font-size: 2rem;\n    border-radius: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: #111827;\n  line-height: 1.3;\n  \n  @media (min-width: 640px) {\n    font-size: 1.125rem;\n    margin-bottom: 0.625rem;\n  }\n  \n  @media (min-width: 1024px) {\n    font-size: 1.25rem;\n    margin-bottom: 0.75rem;\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  color: #6b7280;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  \n  @media (min-width: 640px) {\n    font-size: 0.9375rem;\n    line-height: 1.6;\n  }\n  \n  @media (min-width: 1024px) {\n    font-size: 1rem;\n    line-height: 1.6;\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { Card, CardBody } from '@heroui/react';
// 스타일 컴포넌트
var SectionTitle = styled.h2(_templateObject());
var GridContainer = styled.div(_templateObject1());
var StyledFeatureCard = styled(Card)(_templateObject2());
var CardBodyCentered = styled(CardBody)(_templateObject3());
var IconWrapper = styled.div(_templateObject4());
var FeatureTitle = styled.h3(_templateObject5());
var FeatureDescription = styled.p(_templateObject6());
/**
 * 기능 소개 그리드 컴포넌트
 * 
 * @example
 * ```tsx
 * <FeatureGrid
 *   title="핵심 기능"
 *   features={[
 *     {
 *       icon: "🤖",
 *       title: "AI 코딩 도우미",
 *       description: "코드 생성, 자동 완성, 실시간 디버깅으로 생산성을 높이세요."
 *     },
 *     {
 *       icon: "🎓",
 *       title: "AI 맞춤형 튜터",
 *       description: "개인의 학습 속도와 스타일에 맞춰 개념 설명과 문제 해결을 지원합니다."
 *     }
 *   ]}
 * />
 * ```
 */ export var FeatureGrid = function(param) {
    var title = param.title, features = param.features, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, /*#__PURE__*/ React.createElement(SectionTitle, null, title), /*#__PURE__*/ React.createElement(GridContainer, null, features.map(function(feature, index) {
        return /*#__PURE__*/ React.createElement(StyledFeatureCard, {
            key: index
        }, /*#__PURE__*/ React.createElement(CardBodyCentered, null, /*#__PURE__*/ React.createElement(IconWrapper, null, feature.icon), /*#__PURE__*/ React.createElement(FeatureTitle, null, feature.title), /*#__PURE__*/ React.createElement(FeatureDescription, null, feature.description)));
    })));
};
export default FeatureGrid;
